import { call, put, takeLatest } from "redux-saga/effects";
import { push } from "react-router-redux";
import swal from "sweetalert";
import api from "services/api";

import {
  Creators as ReasonsActions,
  Types as ReasonsTypes,
} from "store/ducks/reasons";

function* getReasonRequest(action) {
  try {
    const { id } = action.payload;
    const url = `user/v2/document_request_reasons/${id}`;
    const response = yield call(api.get, url);

    const data = {
      id: response.data.data.id,
      title: response.data.data.attributes.title,
      description: response.data.data.attributes.description,
      alias: response.data.data.attributes.alias,
    };

    yield put(ReasonsActions.getReasonSuccess(data));
  } catch (error) {
    yield put(ReasonsActions.getReasonFailure());
  }
}

function* getReasonsRequest() {
  try {
    const url = `user/v2/document_request_reasons?page=1&per=9999`;
    const response = yield call(api.get, url);

    const data = response.data.data.map((r) => ({
      id: r.id,
      title: r.attributes.title,
      description: r.attributes.description,
      alias: r.attributes.alias,
    }));

    yield put(ReasonsActions.getReasonsSuccess(data));
  } catch (error) {
    yield put(ReasonsActions.getReasonsFailure());
  }
}

function* createReasonRequest(action) {
  try {
    const { data } = action.payload;
    const url = "user/v2/document_request_reasons";
    yield call(api.post, url, { document_request_reason: data });

    yield put(push("/reasons/list"));
    yield call(swal, "Criada", "Razão criada com sucesso!", "success");
    yield put(ReasonsActions.createReasonSuccess());
  } catch (error) {
    yield call(
      swal,
      "Falha ao criar",
      "Não foi possível criar a razão.",
      "error"
    );
    yield put(ReasonsActions.createReasonFailure());
  }
}

function* updateReasonRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = `user/v2/document_request_reasons/${id}`;
    yield call(api.put, url, data, { document_request_reason: data });

    yield put(push("/reasons/list"));
    yield call(swal, "Atualizada", "Razão atualizada com sucesso!", "success");
    yield put(ReasonsActions.updateReasonSuccess());
  } catch (error) {
    yield call(
      swal,
      "Falha ao atualizar",
      "Não foi possível atualizar a razão.",
      "error"
    );
    yield put(ReasonsActions.updateReasonFailure());
  }
}

export default function* saga() {
  yield takeLatest(ReasonsTypes.GET_REQUEST, getReasonRequest);
  yield takeLatest(ReasonsTypes.GET_LIST_REQUEST, getReasonsRequest);
  yield takeLatest(ReasonsTypes.CREATE_REQUEST, createReasonRequest);
  yield takeLatest(ReasonsTypes.UPDATE_REQUEST, updateReasonRequest);
}
